module.exports = __webpack_public_path__ + "static/esdras.f4572790.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/esdras.jpeg
// module id = 167
// module chunks = 0